import type { StackedBarGroup } from './model/stacked-bar.types';

/**
 * 세로축 눈금: 받은 yTicks(오름차순으로) 또는 0 ~ 가장 큰 합계를 4등분한 5개(청사진 StackedBarChart "자료").
 * 축의 맨 위 = max(가장 큰 합계, 가장 큰 눈금) — 막대 높이는 합계에 비례한다(구의 40~90% 정규화는 버렸다, DD-54 #2).
 */
export function stackedBarScale(
  groups: readonly StackedBarGroup[],
  yTicks?: readonly number[],
): { max: number; ticks: number[] } {
  const maxTotal = Math.max(
    0,
    ...groups.map((group) => (Number.isFinite(group.total) ? group.total : 0)),
  );
  const ticks =
    yTicks && yTicks.length > 0
      ? [...yTicks].sort((a, b) => a - b)
      : Array.from({ length: 5 }, (_, index) => (maxTotal / 4) * index);
  const max = Math.max(maxTotal, ...ticks) || 1;
  return { max, ticks };
}

/**
 * 조각을 아래부터 쌓은 위치: 막대 높이에 대한 시작 · 높이 비율(0~1). 음수 · 숫자가 아닌 비율은 0.
 * 비율 합이 1 을 넘으면(캡테이블 현재 줄 — 스톡옵션 · 리픽싱이 발행 주식 밖에서 더해진다) 합으로 나눠 막대 안에 넣는다.
 */
export function stackedSegments(group: StackedBarGroup): { start: number; size: number }[] {
  const sizes = group.segments.map((segment) =>
    Number.isFinite(segment.value) && segment.value > 0 ? segment.value : 0,
  );
  const scale = Math.max(
    1,
    sizes.reduce((sum, size) => sum + size, 0),
  );
  let start = 0;
  return sizes.map((raw) => {
    const size = raw / scale;
    const placed = { start, size };
    start += size;
    return placed;
  });
}
